<div class="delete-confirmation">
  <div class="delete-confirmation__header">
    <h2 class="delete-confirmation__title">Warning</h2>
    <div class="delete-confirmation__close">
      <span nz-icon nzType="close" nzTheme="outline" (click)="close(false)"></span>
    </div>
  </div>

  <div class="delete-confirmation__body">
    <p class="delete-confirmation__message">{{ data.message }}<ng-container *ngIf="data.name">&ngsp;<span class="delete-confirmation__name">{{ data.name }}</span>?</ng-container></p>
  </div>

  <div class="delete-confirmation__footer">
    <button
      nz-button
      type="button"
      nzType="default"
      class="delete-confirmation__btn button-cancel"
      (click)="close(false)"
    >
      Go back
    </button>
    <button
      nz-button
      type="button"
      nzType="primary"
      class="delete-confirmation__btn"
      (click)="close(true)"
    >
      Confirm
    </button>
  </div>
</div>
